import React, { Component } from 'react'
import pt from 'prop-types'
import { SortableContainer } from 'react-sortable-hoc'
import SortableItem from './SortableItem'
import './SortableContainer.scss'

class SortableCollection extends Component {
  render() {
    const { items, state } = this.props

    return (
      <div
        className="sortable-container-menu"
        ref={container => {
          this.container = container
        }}
      >
        {items.map((value, index) => (
          <SortableItem key={`item-${index}`} index={index} position={index} value={value} state={state} />
        ))}
      </div>
    )
  }
}

SortableCollection.propTypes = {
  items: pt.array,
  state: pt.object
}

export default SortableContainer(SortableCollection)
